export default {
  timeframe: [{
    type: 'today',
    name: 'Today'
  }, {
    type: 'yesterday',
    name: 'Yesterday'
  },
  {
    type: 'last7',
    name: 'Last 7 days'
  },
  {
    type: 'last30',
    name: 'Last 30 days'
  },
  {
    type: 'thisMonth',
    name: 'This Month'
  },
  {
    type: 'lastMonth',
    name: 'Last Month'
  }
  ],
  graph: [{
    type: 'ga:users',
    name: 'Users'
  }
  // {
  //   type: 'ga:goalConversionRateAll',
  //   name: 'Conversions'
  // }
  ],
  bigNumber: [{
    type: 'realtime',
    name: 'Realtime Visitors'
  },
  {
    type: 'ga:users',
    name: 'Visitors'
  }
  ],
  others: [{
    type: 'ga:avgSessionDuration',
    name: 'Session Time'
  },
  {
    type: 'ga:users',
    name: 'Users'
  },
  {
    type: 'ga:sessions',
    name: 'Sessions'
  },
  {
    type: 'usersPerDay',
    name: 'Users per day'
  },
  {
    type: 'ga:newUsers',
    name: 'New Users'
  },
  {
    type: 'ga:pageviews',
    name: 'Page Views'
  },
  {
    type: 'ga:bounceRate',
    name: 'Bounce Rate'
  },
  {
    type: 'ga:percentNewSessions',
    name: 'New Session %'
  },
  {
    type: 'ga:goalCompletionsAll',
    name: 'All goals'
  },
  {
    type: 'ga:goalConversionRateAll',
    name: 'All Goals CR %'
  },
  {
    type: 'ga:goalValueAll',
    name: 'All goals value'
  },
  {
    type: 'ga:totalEvents',
    name: 'Total Events'
  },
  {
    type: 'ga:transactions',
    name: 'All transactions'
  },
  {
    type: 'ga:transactionRevenue',
    name: 'All transaction revenue'
  },
  {
    type: 'ga:transactionRevenuePerSession',
    name: 'Avg. revenue per session'
  }
  ],
  names: {
    'ga:avgSessionDuration': 'Session Time',
    'ga:newUsers': 'New Users',
    'ga:sessions': 'Sessions',
    'usersPerDay': 'User / day',
    'ga:pageviews': 'Page Views',
    'ga:bounceRate': 'Bounce Rate',
    'ga:users': 'Users',
    'realtime': 'Realtime Visitors',
    'ga:percentNewSessions': 'New Session',
    'ga:goalCompletionsAll': 'All Goals',
    'ga:goalConversionRateAll': 'Goals CR',
    'ga:goalValueAll': 'Goals value',
    'ga:totalEvents': 'Total Events',
    'ga:transactions': 'Transactions',
    'ga:transactionRevenue': 'Transaction revenue',
    'ga:transactionRevenuePerSession': 'Revenue / session'
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/dropdown-options.js